import { logout } from '../auth.service';
import Login from '../../pages/Login';

const CorujaClube = () =>
{    
    localStorage.setItem("tenantId", "corujaclube");
    localStorage.setItem("logoVertical", "logocorujaclube");
    logout();
    
    return Login();
};

export default CorujaClube;